import script from "./ListGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListGrid.vue?vue&type=script&lang=ts&setup=true"

import "./ListGrid.vue?vue&type=style&index=0&id=bb125a38&lang=scss&scoped=true"
import "./ListGrid.vue?vue&type=style&index=1&id=bb125a38&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb125a38"]])

export default __exports__